export const enum EStatusGenerico {
    ENVIADO = 'Enviado',
    DESOBRIGADO = 'Desobrigado',
    PENDENTE_RECEBIMENTO = 'Pendente de Recebimento',
    ACOMPANHAMENTO_DO_PROCESSO = 'Acompanhamento do Processo',
    RECEBIDO = 'Recebido',
    PENDENTE_ENVIO = 'Pendente de Envio',
    PENDENTE = 'Pendente',
    EM_NEGOCIACAO = 'Em negociação',
    MINUTA_VALIDADA = 'Minuta Validada',
    MINUTA_RECUSADA = 'Minuta Recusada',
    NAO_NEGOCIAR = 'Não Negociar',
}
